import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import colors from 'components/utils/colors'
import Icon from 'components/Shared/Icon/Index'

const NoDataContent = styled.div`
  display: inline-flex;
  align-items: center;
  color: ${colors.secondary70};
`

const NoDataIcon = styled(Icon)`
  margin-right: 8px;
  &:before {
    color: ${colors.secondary70} !important;
  }
`

const NoDataText = styled.div`
  padding-bottom: 1px;
  font-size: 14px;
  font-weight: 400;
`

const NoData = ({ withIcon, hasFilterOrSearch }) => {
  const { t } = useTranslation()
  const noDataText =
    hasFilterOrSearch ? t('common.noTableDataWithFilterOrSearch') : t('common.noTableData')

  return (
    <NoDataContent data-test='no-data'>
      {withIcon && <NoDataIcon iconName='icon-delete-icon-16' />}
      <NoDataText>{noDataText}</NoDataText>
    </NoDataContent>
  )
}

NoData.propTypes = {
  withIcon: PropTypes.bool,
  hasFilterOrSearch: PropTypes.bool,
}

export default NoData
